import { TFranchise } from '../types/franchiseManagement';
import { RESTRICTION_ACCESS } from '~/constants/integrations';

export const checkFranchisePosAccess = (franchiseProfile: TFranchise, defaultAccess: RESTRICTION_ACCESS | undefined) => {
  if (!franchiseProfile.branches.length) return RESTRICTION_ACCESS.ALLOWED;
  return franchiseProfile.branches.some((branch) => !branch.pos_service_id) ? RESTRICTION_ACCESS.ALLOWED : defaultAccess;
};
